import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { RotateSpinner } from "react-spinners-kit";
import { useState } from "react";

const ProcedureForm = (props) => {
  const [inputFields, setInputFields] = useState(
    props.procedure.Procedures.length > 0 ? props.procedure.Procedures : []
  );

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };
  console.log("props.procedure", props.procedure.Procedures);

  const addFields = () => {
    let newfield = { name: "", code: "" };
    setInputFields([...inputFields, newfield]);
  };

  const RemoveFields = (i) => {
    let data = [...inputFields];
    let newExam = data.filter((exam) => {
      if (exam.name != data[i].name) {
        return exam;
      }
    });
    setInputFields(newExam);
  };
  return (
    <Dialog open={true} onClose={props.handleClose}>
      <DialogTitle>
        {props.edit ? "Edit Procedure" : "Add a new Procedure"}
      </DialogTitle>
      <DialogContent>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Title"
              type="text"
              fullWidth
              helperText={"Procedure's Title"}
              name="Name"
              onChange={props.handleChange}
              value={props.procedure.Name}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="RoomCode"
              type="text"
              name="RoomCode"
              fullWidth
              helperText={"Procedure's RoomCode"}
              onChange={props.handleChange}
              value={props.procedure.RoomCode}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Room"
              type="text"
              name="Room"
              fullWidth
              helperText={"Procedure's Room Name"}
              onChange={props.handleChange}
              value={props.procedure.Room}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Prefix"
              type="text"
              name="Prefix"
              fullWidth
              helperText={"Procedure's Prefix"}
              onChange={props.handleChange}
              value={props.procedure.Prefix}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={9}
              margin="dense"
              label="Description"
              type="text"
              fullWidth
              name="Description"
              helperText="Procedure's Description"
              onChange={props.handleChange}
              value={props.procedure.Description}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              onClick={addFields}
              color="secondary"
              size="small"
            >
              Add More Examinations
            </Button>
          </Grid>
          <Grid item xs={12}>
            {inputFields.map((exam, index) => {
              return (
                <div key={index}>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      label="Description"
                      type="text"
                      name="name"
                      helperText="Examination's Name"
                      onChange={(event) => handleFormChange(index, event)}
                      value={exam.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      label="Description"
                      type="text"
                      name="code"
                      helperText="Examination's Code"
                      onChange={(event) => handleFormChange(index, event)}
                      value={exam.code}
                    />
                  </Grid>
                  <Button
                    variant="outlined"
                    onClick={(event) => RemoveFields(index)}
                    color="primary"
                    size="small"
                  >
                    Remove Exam
                  </Button>
                  <br />
                </div>
              );
            })}
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-start"
          spacing={2}
        >
          <Button
            variant="outlined"
            onClick={props.close}
            color="primary"
            size="large"
            startIcon={<ClearIcon />}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              if (!props.loading) {
                props.save(inputFields);
              }
            }}
            color="secondary"
            size="large"
            startIcon={props.loading ? null : <SaveIcon />}
          >
            {props.loading ? (
              <>
                <RotateSpinner size={20} color="#fff" />
                <span style={{ marginRight: "2px" }}>Saving</span>
              </>
            ) : (
              <span>Save</span>
            )}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ProcedureForm;
